export default __webpack_public_path__ + "static/media/gift-icon-g.51dadd73.svg";